import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { DesignTypeService } from 'services/design-type-service';
import { ErrorService } from 'services/error-service';

@autoinject
export class DesignTypeList {
  private designTypesData: Array<Models.DesignType>;
  private activeTableRow: number;
  private ready: boolean = false;

  constructor(
    private designTypeService: DesignTypeService,
    private errorService: ErrorService,
    private router: Router,
    private eventAggregator: EventAggregator
  ) {}

  private activate(params) {
    if (params.Id) {
      this.activeTableRow = params.Id;
    } else {
      this.activeTableRow = 0;
    }
  }

  private attached(params) {
    this.eventAggregator.subscribe('designTypeListReset', (value) => {
      this.activeTableRow = null;
      return this.updateView();
    });
    this.updateView();
  }

  private async updateView() {
    try {
      this.designTypesData =
        await this.designTypeService.getListWithDefaultNetShape();
      this.ready = true;
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  private gotoDetailView(id) {
    this.activeTableRow = id;
    this.router.navigateToRoute('design-type-detail', { Id: id });
  }
}
